module.exports = __webpack_public_path__ + "img/qcode.a4e00224.jpg";